import { HideSpinner, ShowSpinner, IHideSpinnerPayload, IShowSpinnerPayload } from './../actions/system-loader.actions';
import { filter, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class SystemLoaderEffects {

  constructor(private actions$: Actions) { }

  showLoaderEffect$ = createEffect(() => {
    return this.actions$.pipe(
      filter((action: any) => {
        return action?.showLoader ? action : null;
      }),
      map((action: IShowSpinnerPayload) => {
        return new ShowSpinner(action);
      })
    );
  });

  hideLoaderEffect$ = createEffect(() => {
    return this.actions$.pipe(
      filter((action: any) => {
        return action?.triggerAction ? action : null;
      }),
      map((action: IHideSpinnerPayload) => {
        return new HideSpinner(action);
      })
    );
  });

}
